const isObject = value =>
  typeof value === 'object' &&
  value !== null &&
  !(value instanceof RegExp) &&
  !(value instanceof Error) &&
  !(value instanceof Date);

const mapObject = (object, fn, options, isSeen = new WeakMap()) => {
  options = {
    deep: false,
    target: {},
    ...options
  };

  if (isSeen.has(object)) {
    return isSeen.get(object);
  }

  isSeen.set(object, options.target);

  const { target } = options;
  delete options.target;

  const mapArray = array =>
    array.map(element =>
      isObject(element) ? mapObject(element, fn, options, isSeen) : element
    );
  if (Array.isArray(object)) {
    return mapArray(object);
  }

  for (const [key, value] of Object.entries(object)) {
    let [newKey, newValue] = fn(key, value, object);

    if (options.deep && isObject(newValue)) {
      newValue = Array.isArray(newValue)
        ? mapArray(newValue)
        : mapObject(newValue, fn, options, isSeen);
    }

    target[newKey] = newValue;
  }

  return target;
};

export default mapObject;
